<style scoped>
 div.ctrl-change-knob {
   margin-left: 20px;
 }
 div.knob-title-text-00 {
   font-size: 11px;
 }
 div.audition-card-00 {
   position: relative;
   border-radius: 0 0 5px 5px;
   width: 100%;
   height: 100%;
 }
 div.tools-00 {
   margin-left: 10px
 }
</style>
<template>
  <div class="container-00">

      <!-- -->
    <div class="each-controller-top justify-align-center direction-row audition-card-00">

      <div class="tools-00 card-title-00 justify-align-center direction-column">
        <v-btn x-small icon color="#FF6F00" v-on:click="sendPanic()"><v-icon>mdi-car-brake-alert</v-icon></v-btn>
        <v-btn x-small icon v-on:click="dump_audition_param()"><v-icon>mdi-text-box-outline</v-icon></v-btn>
      </div>

      <div class="justify-align-center direction-row">
        <div>
          <webaudio-keyboard width="640" height="80" keys="61" min="27" v-on:change="onUpdateKey($event)"></webaudio-keyboard>
        </div>
        <div class="ctrl-change-knob justify-align-center direction-column">
          <div><webaudio-knob width="36" id="knob01" height="36" min="0" max="127" defvalue=64 :value="audition_param_b0_02" v-on:change="onUpdateParam('b0_02', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Breath Ctrl<br/>%d %"></webaudio-knob></div>
          <div class="knob-title-text-00 label-title-00">Breath Ctrl</div>
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    x-small
                    button
                    v-bind="attrs"
                    v-on="on"
                    color="rgb(193, 209, 224)"
                    @click="sendPatchInEditMode">audition</v-btn>
              </template>
              <span>Try sound  without sync</span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </div>
    <!-- -->

  </div>
</template>

<script>
 export default {
   name: 'Audition',

   props: ['label'],

   watch: {
     'audition_param.b0_02': function(newValue) {
       this.$set(this.$data.audition_param, 'd0', newValue)
     }
   },

   methods: {
     sendPanic: function() {
       const messages = []
       //messages.push(new Uint8Array([0xb0, 0x7b, 0x00])) // all note off
       messages.push([0xb0, 0x7b, 0x00]) // all note off
       this.$router.app.$children[0].sendArrayChannelMessageApp(messages)
       console.log('[message sent] ', messages)
     },
     sendPatchInEditMode: async function() {
       const patchNo = this.$store.getters.getWorkingPatchIdx()
       const editPatch = this.$store.getters.getOneEditPatch(patchNo)
       const encodedPatch = this.$router.app.$children[0].encodeOnePatchApp(editPatch.decoded)
       await this.$router.app.$children[0].sendOnePatchApp(encodedPatch, () => {}, 'edit')
       console.log('sendPatchInEditMode')
     },
     dump_audition_param: function() {
       console.log(`[local:${this.label}]`, this.$data.audition_param)
     },
     onUpdateKey: function(event) {
       const keyVel = event.note
       const messages = []
       if (keyVel[0]==1) {
         messages.push([0xb0, 0x7b, 0x00]) // all note off
         messages.push([0x90, keyVel[1], 0x40]) // always send velocity 0x40(64)
         messages.push([0xb0, 0x02, this.$data.audition_param.b0_02]) // Breath Ctrl
         messages.push([0xd0, this.$data.audition_param.b0_02]) // Pressure
       } else {
         messages.push([0x90, keyVel[1], 0x00])
         messages.push([0xb0, 0x02, 0x00]) // Breath Ctrl
       }
       this.$router.app.$children[0].sendArrayChannelMessageApp(messages)
       //console.log('[message sent] ', messages)
     },
     onUpdateParam: function(key, val) {
       this.$set(this.$data.audition_param, key, val)
       const messages = []
       messages.push([0xb0, 0x02, val]) // Breath Ctrl
       messages.push([0xd0, val]) // Pressure

       this.$router.app.$children[0].sendArrayChannelMessageApp(messages)
       console.log('[message sent] ', messages)
     },
     forceSetParam: function(val=0) {
       this.$set(this.$data.audition_param, 'b0_02', val)
       this.$set(this.$data.audition_param, 'd0', val)
     }
   },

   created: function() {
     console.log(`<CREATED> label=[${this.label}]`)
   },

   computed: {
     'audition_param_b0_02': {
       get: function() {
         return this.$data.audition_param.b0_02
       }
     },
     overlay: {
       get: function() {
         return this.$store.getters.getDemoMode()
       },
       set: function() {
       }
     }
   },

   data: () => ({
     audition_param: {
       b0_02: 64,
       d0: 64
     }
   })
 }
</script>
